import axios from "axios";
import { RouteUrls } from "../common/RouteUrls";

export const targetRedirectApi = async (orgId, userId, authToken) => {
    try {
        const response = await axios({
            method: 'POST',
            url: RouteUrls.TARGET_REDIRECT_ENDPOINT,
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
                'correlation-id': '12345',
                'client-id': 'PNET',
            },
            data: {
                organizationNumber: orgId,
                loginName: userId
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user ID : ', error);
        throw error;
    }
};